import { functions, httpsCallable } from '@/firebase'

export async function editUser(payload) {
    const { data } = await httpsCallable(functions, 'editUser')(payload)
    return data
}
